// import React from "react";
// import { Dialog } from "primereact/dialog";
// import AddingNewSubdistrict from "../Add-Subdistrict/Subdistrict-adding";
 
// const AddSubdistrict = ({
//   showAddUserModal,
//   hideAddUserModal
// }: any) => {
//   return (
//     <Dialog
//       visible={showAddUserModal}
//       className="quickview"
//       breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
//       modal
//       onHide={hideAddUserModal}
//     >
//       <AddingNewSubdistrict />
//     </Dialog>
//   );
// };
 
// export default AddSubdistrict;
import React from "react";
import { Dialog } from "primereact/dialog";
import AddingNewSubdistrict from "../Add-Subdistrict/Subdistrict-adding";
 
// Define types for the props
interface AddSubdistrictProps {
  showAddUserModal: boolean;
  hideAddUserModal: () => void;
}
 
const AddSubdistrict: React.FC<AddSubdistrictProps> = ({
  showAddUserModal,
  hideAddUserModal,
}) => {
  return (
    <Dialog
      visible={showAddUserModal}
      className="quickview"
      breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
      modal
      onHide={hideAddUserModal}
    >
      <AddingNewSubdistrict
        showDialog={showAddUserModal}
        dialogHeader=""
        onClose={hideAddUserModal}
      />
    </Dialog>
  );
};
 
export default AddSubdistrict;